// @ts-nocheck
"use strict";
/* #region hide menu icon on click */ var Icons = document.querySelector(".top-bar__icons");
var menuIcon = document.querySelector(".top-bar__icon--menu");
var closeIcon = document.querySelector(".top-bar__icon--close");
menuIcon.addEventListener("click", function() {
    Icons.classList.toggle("top-bar__icons--show");
});
closeIcon.addEventListener("click", function() {
    Icons.classList.toggle("top-bar__icons--show");
}); /* #end hide menu icon on click */ 

//# sourceMappingURL=index.273a4be1.js.map
